export default function WhoCanApply() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              ¿Quién puede solicitar este visado?
            </h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-12">
            <div className="space-y-8">
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl shadow-lg p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-blue-600 rounded-full mb-6">
                  <i className="ri-building-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  1. Empleados de empresas extranjeras
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Pueden aplicar quienes trabajen de manera remota para una empresa situada fuera de España y puedan demostrar su relación laboral en países cubiertos por convenio bilateral en materia de seguridad social.
                </p>
              </div>

              <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl shadow-lg p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-green-600 rounded-full mb-6">
                  <i className="ri-user-star-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  2. Autónomos / Freelancers
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                  Profesionales que ofrezcan servicios a una o varias empresas extranjeras.
                </p>
                <div className="bg-white rounded-lg p-4 border-l-4 border-green-600">
                  <p className="text-sm font-semibold text-gray-900">
                    <i className="ri-information-fill text-green-600 mr-2"></i>
                    Requisito clave: solo el 20% de los ingresos puede proceder de España.
                  </p>
                </div>
              </div>
            </div>

            <div className="order-first lg:order-last">
              <img 
                src="https://static.readdy.ai/image/97c320206ed08475f986f4f05d477848/791e789dbcb2c34218392641a20c914a.png" 
                alt="Nómadas digitales trabajando en España - Visado de trabajo remoto"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
            </div>
          </div>

          <div className="text-center mt-12">
            <a 
              href="#consulta" 
              className="inline-block bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Evaluar mi Elegibilidad
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
